"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var iris_1 = require("iris");
var actions = {
    'currency/fetchConversionRate': function (_a, args) {
        var commit = _a.commit, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var key, json_1, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        key = JSON.stringify(args);
                        commit('ajax/setLoading', key);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, iris_1.client.exchangeRates()];
                    case 2:
                        json_1 = _b.sent();
                        if (getters['ajax/lastFetchRequestKey'] === key) {
                            if (json_1 &&
                                json_1['EUR'] &&
                                json_1['EUR']['CHF'] &&
                                json_1['EUR']['CHF']['rate'] &&
                                json_1['EUR']['CHF']['code']) {
                                commit('currency/setConversion', json_1['EUR']['CHF']['rate']);
                                commit('currency/setCurrency', lodash_1.findKey(getters['currency/currencyList'].currencies, function (val) {
                                    return val === json_1['EUR']['CHF']['code'];
                                }));
                                commit('currency/setConvert', true);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        // TODO: retry?
                        console.log('ajax error on fetchCoversionRate: ', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    'currency/updateStoreCurrency': function (_a, storeCurrency) {
        var commit = _a.commit;
        commit('currency/setStoreCurrency', storeCurrency);
    },
    'currency/updateCurrency': function (_a, currency) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('currency/setCurrency', currency);
                        if (!(currency === 'DE')) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch('currency/updateConversion', 1)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, dispatch('currency/fetchConversionRate', {})];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    'currency/updateConversion': function (_a, conversion) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                commit('currency/setConversion', conversion);
                if (conversion !== 1) {
                    commit('currency/setConvert', true);
                }
                else {
                    commit('currency/setConvert', false);
                }
                return [2 /*return*/];
            });
        });
    },
    'currency/currencyConversion': function (_a, active) {
        var commit = _a.commit, getters = _a.getters, dispatch = _a.dispatch;
        commit('currency/currencyConversion', active);
        if (active === true && getters['currency/conversion'] !== 1) {
            dispatch('currency/fetchConversionRate', {});
        }
    },
};
var getters = {
    'currency/storeCurrency': function (state) {
        return state.storeCurrency;
    },
    'currency/currency': function (state) {
        return state.storeCurrency.currency;
    },
    'currency/convert': function (state) {
        return state.storeCurrency.convert;
    },
    'currency/conversion': function (state) {
        return state.storeCurrency.conversion;
    },
    'currency/currencySign': function (state, getters) {
        return state.currencyList.currencies[getters['currency/currency']];
    },
    'currency/currencyConversion': function (state) {
        return state.currencyConversion;
    },
    'currency/currencyList': function (state) {
        return state.currencyList;
    },
};
var mutations = {
    'currency/setCurrency': function (state, currency) {
        state.storeCurrency.currency = currency;
    },
    'currency/setConvert': function (state, convert) {
        state.storeCurrency.convert = convert;
    },
    'currency/setConversion': function (state, conversion) {
        state.storeCurrency.conversion = conversion;
    },
    'currency/setStoreCurrency': function (state, storeCurrency) {
        state.storeCurrency = storeCurrency;
    },
    'currency/currencyConversion': function (state, active) {
        state.currencyConversion = active;
    },
};
exports.default = {
    actions: actions,
    getters: getters,
    mutations: mutations,
};
//# sourceMappingURL=currencyManagement.js.map